module.exports = __webpack_public_path__ + "img/company-register.b6e70df1.svg";